"use strict";
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
module.exports = asciiWords;
//# sourceMappingURL=_asciiWords.js.map